function service(state = {
  serviceInfo: null, serviceInvoice: '', serviceUsedParts: '', serviceAttachments: [], usedPartsList: [], serialHistoryPopup: '',
  serialHistory: [], selectStaffPopup: '', agentList: [], repairBugList: [], faultsByCustomer: [], customerFaultsPopStatus: '',
  serviceStatusList: [], customerServiceList: [], activeUnusedCards: [], serviceMessageList:[], customerServiceFilters:{}

}, action) {

  switch (action.type) {

    case "GET_SERVICE":
      return {
        ...state,
        serviceInfo: action.data
      }
    case "GET_SERVICE_INVOICE":
      return {
        ...state,
        serviceInvoice: action.data
      }
    case "GET_SERVICE_USEDPARTS":
      return {
        ...state,
        serviceUsedParts: action.data
      }
    case "GET_SERVICE_ATTACHMENTS":
      return {
        ...state,
        serviceAttachments: action.data
      }
    case "GET_AGENT_LIST":
      return {
        ...state,
        agentList: action.data
      }

    case "SEARCH_USED_PARTS":
      return {
        ...state,
        usedPartsList: action.data
      }
    case "SET_SERIALHISTORY_POPUP":
      return {
        ...state,
        serialHistoryPopup: action.data
      }
    case "GET_SERIAL_HISTORY":
      return {
        ...state,
        serialHistory: action.data

      }
    case "SET_SELECTSTAFF_POPUP":
      return {
        ...state,
        selectStaffPopup: action.data
      }
    case "GET_REPAIR_BUGS":
      return {
        ...state,
        repairBugList: action.data
      }
    case "LOAD_FAULTS_CUSTOMER":
      return {
        ...state,
        faultsByCustomer: action.data
      }
    case "SET_CUSTOMER_FAULTS":
      return {
        ...state,
        customerFaultsPopStatus: action.data
      }
    case "GET_SERVICE_STATUS":
      return {
        ...state,
        serviceStatusList: action.data
      }
    case "SIGNATURE_POP":
      return {
        ...state,
        signaturePopStaus: action.data
      }
    case "SET_BORROW_LIST_POP":
      return {
        ...state,
        borrowListPop: action.data
      }
    case "GET_SERVICE_RECEIPT":
      return {
        ...state,
        serviceReceipt: action.data
      }
    case "GET_SERVICE_TOTALCOST":
      return {
        ...state,
        serviceTotalCost: action.data
      }
    case "FETCH_USEDPARTS_BORROWLIST":
      return {
        ...state,
        usedPartsBorrowList: action.data
      }
    case "CUSTOMER_SERVICE_LIST":
      return {
        ...state,
        customerServiceList: action.data
      }
      case "CUST_SERVICE_FILTERS":
        return{
          ...state,
          customerServiceFilters: action.data
        }
    case "ACTIVE_UNUSED_CARDS": 
      return {
        ...state,
        activeUnusedCards: action.data
      }
      case "SERVICE_MESSAGE_LIST": 
      return {
        ...state,
        serviceMessageList: action.data
      }
    default:
  return state;
}
}

export default service;